/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Actions_LabelInputs */



/**
* | output |
* | --- |
* | "Correction actions" |
*
* @param {Spellcheck_Actions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_actions_label = /** @type {((inputs?: Spellcheck_Actions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Actions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actions de correction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Korrekturmaßnahmen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Azioni correttive")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Меры по исправлению ситуации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acciones correctivas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("纠正措施")
	if (locale === "ja") return /** @type {LocalizedString} */ ("是正措置")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सुधारात्मक कार्रवाइयां")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ações corretivas")
	return /** @type {LocalizedString} */ ("Correction actions")
});